function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.315 20.494H7.58s.842 1.263 0 2.526h2.736c-.842-1.263 0-2.42 0-2.526z",
  fill: "#F68C1F"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.684 20.494s.105.105.105.21c0 0 .842.106 1.264.737.315.527.105 1.263 0 1.474h1.263c-.842-1.263 0-2.526 0-2.526-.632.105-2 .105-2.632.105z",
  fill: "#EE8422"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.316 15.126c.737-.843 1.579-1.369 2.42-1.79.211-.105.422-.421.422-.632v-4.21c0-.316-.421-.105-.632-.21-.316 0-.105.42-.21 1.157a.943.943 0 01-.948.948h-1.052v-.842h1.052c.21 0 .106-.211.106-1.158 0-.632.42-1.053 1.052-1.053h.421c.632 0 1.053.421 1.053 1.053v4.21c0 1.895-2.105 1.684-3.895 4.21-.105.211-.631.738-.631.738.42-.737.736-1.58.842-2.421z",
  fill: "#E87F24"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.684 15.126c-.737-.843-1.579-1.369-2.42-1.79-.211-.105-.422-.421-.422-.632v-4.21c0-.316.421-.105.632-.21.315 0 .105.42.21 1.157 0 .527.421.948.948.948h1.052v-.842H2.632c-.21 0-.106-.211-.106-1.158 0-.632-.42-1.053-1.052-1.053h-.421C.42 7.336 0 7.757 0 8.389v4.21c0 1.895 2.105 1.684 3.895 4.21.105.211.631.738.631.738-.526-.737-.737-1.58-.842-2.421z",
  fill: "#F68C1F"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.895 6.283H6.21L4.737 7.652h8.631l-1.473-1.369z",
  fill: "#FEE900"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14 7.547H4a.83.83 0 00-.842.842h11.684c0-.421-.421-.842-.842-.842z",
  fill: "#FDB515"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.158 8.494v.21c0 .316.21.527.526.527h10.737c.316 0 .526-.21.526-.527v-.21H3.157z",
  fill: "#D57428"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.316 15.126c-.106.842-.316 1.684-.737 2.42 0 0 .526-.526.631-.736.106-.106.106-.21.211-.21.21-.632.316-1.264.316-1.896a.822.822 0 00-.421.421zM14.736 9.547h-.42v.842h.42v-.842z",
  fill: "#CB7128"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.684 15.126c-.105-.106-.21-.316-.42-.422 0 .632.104 1.264.315 1.895.105.105.105.21.21.21.106.211.632.738.632.738-.421-.737-.632-1.58-.737-2.421zM3.79 9.547h-.421v.842h.42v-.842z",
  fill: "#F16022"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M3.684 9.126v5.578c0 2.421 1.58 4.527 3.79 5.158h2.947c2.21-.631 3.79-2.736 3.79-5.158V9.126H3.684z",
  fill: "#FDB515"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M6.631 19.547c1.58-1.264 2.527-3.474 2.527-5.79a8.202 8.202 0 00-1.369-4.526H3.58v5.579c.105 2 1.368 3.79 3.052 4.737z",
  fill: "#FDB515"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M7.474 19.862v.737h2.947v-.737H7.474z",
  fill: "#D57428"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M7.474 20.073h2.947v-.21H7.474v.21z",
  fill: "#BD6728"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M10.526 23.02H7.58c-.316 0-.526.21-.526.527v.105h3.894v-.105c0-.316-.21-.527-.42-.527z",
  fill: "#D57428"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M6.421 23.652v5.263h5.053v-5.263H6.42z",
  fill: "#FCB017"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M6.421 28.6h.421c1.684 0 3.053-1.685 3.053-3.79 0-.421-.105-.842-.105-1.158H6.42v4.947z",
  fill: "#FCB017"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M12.105 28.915h-6.21c-.21 0-.316.21-.316.316v.105h6.947v-.105c-.105-.106-.21-.316-.42-.316z",
  fill: "#FEDC00"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M4.842 29.441V32.6h8.316v-3.158H4.842z",
  fill: "#89331C"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M4.842 29.441v3.053h.421c2.632 0 4.737-1.263 5.264-3.053H4.842z",
  fill: "#89331C"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M13.474 32.494H4.526L4 33.02v.105h10v-.105l-.526-.526z",
  fill: "#FDB515"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M9.579 5.23H8.42c-.316 0-.632.317-.632.632v.316h2.527v-.316c-.106-.315-.316-.631-.737-.631z",
  fill: "#F68C1F"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.69,
  d: "M9.158 5.652c0-.21-.421-.316-1.053-.316-.21.105-.42.316-.42.632v.105c.841-.105 1.473-.21 1.473-.421z",
  fill: "#F68C1F"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M8.421 4.704v.527H9.58v-.527H8.421z",
  fill: "#D57428"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M8.421 4.915c.21 0 .421.105.632.105.21 0 .42 0 .631-.105v-.21H8.526v.21h-.105z",
  fill: "#BD6728"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M9.008 4.801a2.316 2.316 0 10-.129-4.63 2.316 2.316 0 00.129 4.63z",
  fill: "#D57428"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M11.158 2.494c0 .21-.21.421-.316.632-.105.21 0 .526-.105.631-.105.21-.421.21-.632.316-.21.105-.316.42-.526.42-.21.106-.421-.104-.632-.104-.21 0-.526.105-.631.105-.21-.105-.316-.316-.527-.421l-.631-.316c-.105-.21-.105-.421-.105-.631-.106-.211-.316-.422-.316-.632 0-.21.21-.421.316-.632.105-.21 0-.526.105-.631.105-.21.42-.21.631-.316C8 .81 8.105.494 8.316.494c.21-.105.42.105.631.105.21 0 .527-.105.632-.105.21.105.316.316.526.421l.632.316c.105.21.105.42.105.631.21.21.316.421.316.632z",
  fill: "#F68C1F"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M9.58 4.494H8.42a.226.226 0 01-.21-.21L8 4.072c-.106-.105-.211-.105-.317-.105-.105 0-.21-.106-.315-.21-.106-.106-.106-.211-.106-.317 0-.105 0-.21-.105-.315 0-.106-.105-.211-.105-.316-.105-.106-.105-.21-.105-.316 0-.105.105-.21.105-.316 0-.105.105-.21.105-.316 0-.105 0-.21.105-.315 0-.106 0-.21.106-.316.105-.105.21-.105.315-.21.106 0 .21-.106.316-.106l.21-.21.211-.211h1.263c.106 0 .21.105.21.21l.211.211c.106.105.21.105.316.105.105 0 .21.106.316.21.105.106.105.211.105.317 0 .105 0 .21.105.315 0 .106.106.21.106.316.105.105.105.21.105.316 0 .105-.105.21-.105.316 0 .105-.106.21-.106.316 0 .105 0 .21-.105.315 0 .106 0 .21-.105.316-.105.105-.21.105-.316.21-.105 0-.21.106-.316.106l-.21.21c-.105.106-.21.106-.316.21z",
  fill: "#FDB515"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M8.947 4.073a1.579 1.579 0 100-3.158 1.579 1.579 0 000 3.158z",
  fill: "#F68C1F"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M8.947 4.073a1.579 1.579 0 100-3.158 1.579 1.579 0 000 3.158z",
  fill: "#D57428"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M8.947 3.862a1.368 1.368 0 100-2.736 1.368 1.368 0 000 2.736z",
  fill: "#FEDC00"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M9.579 3.757L7.894 1.652c-.105.105-.105.105-.105.21l1.579 2s.105 0 .21-.105zM8.736 3.862L7.58 2.39v.21l.947 1.158c.105.105.21.105.21.105zM10.105 3.441L8.42 1.336s-.106 0-.106.105l1.79 2c-.105 0-.105 0 0 0zM10.316 2.81L8.947 1.126h-.21L10.21 3.02c.105 0 .105-.105.105-.21z",
  fill: "#FCB017"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M4.526 10.073c-.105 5.053.316 6 .316 6 0 .105 0 .105-.105.105-.106 0-.106 0-.106-.105-.42-1.053-.21-4.737-.105-6z",
  fill: "#FDB515"
});
function SvgUltimate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}
export default SvgUltimate;